import {getStore, setStore} from '@/util/store'
import {dateFormat} from '@/filters/'
import {sendLogs} from '@/api/admin/log'
import request from '@/router/axios'
import config from '../../../version.json'

const logs = {
	state: {
		logsList: getStore({name: 'logsList'}) || [],
	},
	actions: {
		// 发送错误日志
		SendLogs({state, commit}) {
			return new Promise((resolve, reject) => {
				sendLogs(state.logsList)
					.then(() => {
						commit('CLEAR_LOGS')
						resolve()
					})
					.catch((error) => {
						reject(error)
					})
			})
		},
	},
	mutations: {
		ADD_LOGS: (state, {type, message = '', stack, info}) => {
			let errorLog = Object.assign(
				{
					id: state.logsList.length,
					url: window.location.href,
					time: dateFormat(new Date()),
				},
				{
					type,
					message,
					stack,
					info: info.toString() || '未查到错误信息',
				},
			)
			if (
				errorLog.message === `Cannot read properties of undefined (reading 'catch')` ||
				errorLog.message === `Cannot read property 'catch' of undefined` ||
				errorLog.message === `undefined is not an object (evaluating 'u.cancel().catch')` ||
				errorLog.message === 'u.cancel() is undefined' ||
				errorLog.message === 'Maximum call stack size exceeded' ||
				errorLog.info.includes('Promise/async')
			) {
				return
			}

			state.logsList.push(errorLog)
			// let userInfo = sessionStorage.getItem("pigx-userInfo");
			// let versionCode = config.version;
			// //上报js错误
			// let errorMsgDing = `【ie保-js报错 版本号：${versionCode}】报错信息相关:${JSON.stringify(
			//   errorLog,
			// )}, 用户信息:${userInfo} ,设备信息：${navigator.userAgent}`;
			//
			// request({
			//   url: `/safety/common/ding/msg`,
			//   method: "post",
			//   data: {msg: errorMsgDing},
			// });
			setStore({name: 'logsList', content: state.logsList})
		},
		CLEAR_LOGS: (state) => {
			state.logsList = []
			setStore({name: 'logsList', content: state.logsList})
		},
	},
}

export default logs
